import logEvent from '../logEvent';

function logEventHomepage(code, data) {
  logEvent(`SSHP-${code}`, data);
}

export function logEventHomepageView() {
  logEventHomepage('01');
}

export function logEventBanner(data) {
  logEventHomepage('02', data);
}

export function logEventPlanClick() {
  logEventHomepage('03');
}

export function logEventPlanHover() {
  logEventHomepage('04');
}

export function logEventBeneficiary() {
  logEventHomepage('05');
}

export function logEventHelpArticle(data) {
  logEventHomepage('06', data);
}

export function logEventServices(data) {
  logEventHomepage('07', data);
}

export function logEventSocialLinks(data) {
  logEventHomepage('09', data);
}

export function logEventOfferCardClick(data) {
  logEventHomepage('10', data);
}

export function logEventGetOfferClick(data) {
  logEventHomepage('11', data);
}

export function logEventOfferModalClose(data) {
  logEventHomepage('12', data);
}

export function logEventOfferModalScroll(data) {
  logEventHomepage('13', data);
}

export function logEventReferralDisclosureClick(data) {
  logEventHomepage('14', data);
}
